import debug from "debug";

import plugin from '../../lib/plugin';
import Awesomplete from './awesomplete';

const MODULE_NAME = 'app.core/modules/country-select';
const log = debug(MODULE_NAME);



class CountrySelectPlugin {

    constructor (element, options) {
        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$wrapper = this.$element.closest(this.options.wrapper);
        this.$marketChangeConfirmModal = $(this.options.marketChangeConfirmModal);
        this.$marketChangeConfirmModalValueElement = this.$marketChangeConfirmModal.find(this.options.marketChangeConfirmModalValueElement);
        this.$marketChangeSubmitButton = $(this.options.marketChangeSubmitButton);
        this.itemsInCart = this.$marketChangeSubmitButton.attr(this.options.itemsInCartAttr);
        this.currentCountry = this.$marketChangeSubmitButton.attr(this.options.currentCountryAttr);
        this.$dataList = this.$wrapper.find(this.options.dataListElement);
        this.$dropDownElement = this.$wrapper.find(this.options.dropDownElement);
        this.$flagIconElement = this.$wrapper.find(this.options.flagIconElement);
        this.$valueElement = this.$wrapper.find(this.options.valueElement);

        log('CountrySelectPlugin', element);
        var plug = this;
        this.acDropdown = new Awesomplete(this.$element[0], {
            minChars:0,
            maxItems:1000,
            sort:false,
            item: function(text, input) {
                var matchingListItem = plug.$dataList.find('option[value="'+text.value+'"]');
                return plug.initItem(text,input,matchingListItem);
            }
        });

        this.watchDropdown();
        this.watch();
    }

    watchDropdown () {
        if (typeof(this.$dropDownElement) !== 'undefined' && this.$dropDownElement.length > 0) {
            var dropDown = this.$dropDownElement[0];
            var plug = this;
            dropDown.addEventListener("click", function(e) {
                e.preventDefault();
                if (plug.acDropdown.ul.childNodes.length === 0) {
                    plug.acDropdown.minChars = 0;
                    plug.$element.val('');
                    plug.acDropdown.evaluate();
                }
                else if (plug.acDropdown.ul.hasAttribute('hidden')) {
                    plug.$element.val('');
                    plug.acDropdown.evaluate();
                    $(plug.acDropdown.ul).find('li:first-child button').focus();

                }
                else {
                    plug.acDropdown.close();
                }
            });
        }
    }

    initItem(text, input,matchingListItem) {
        var plug = this;
        var isoCode = matchingListItem.length > 0 ? matchingListItem.attr('data-iso-code') : '';
        var isFavourite = matchingListItem.length > 0 ? matchingListItem.attr('data-is-favourite') || '' : '';

        var wrapperDiv = document.createElement('div');
        var innerDiv = document.createElement('div');
        var li = document.createElement('li');
        var button = document.createElement('button');
        var buttonHtml = input.trim() === ""
            ? text.label
            : text.replace(RegExp(input.trim().replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&"), "gi"), "<mark>$&</mark>");

        button.setAttribute('type','button');

        li.setAttribute('aria-selected', false);
        li.setAttribute('data-iso-code', isoCode);
        li.setAttribute('data-is-favourite', isFavourite);

        innerDiv.setAttribute('class', 'input__country-select-flag ' + isoCode);
        wrapperDiv.setAttribute('class', 'input__country-select-flag-wrapper');

        $(wrapperDiv).append(innerDiv);
        $(button).html(buttonHtml);
        $(button).prepend(wrapperDiv);
        $(li).html(button);

        $(button).on("click" , function(evt) {
            evt.preventDefault();
            var listItem = $(this).closest('li')[0];
            plug.acDropdown.select(listItem, listItem);
        });

        $(button).on("focus" , function(evt) {
            plug.acDropdown.open();
        });

        return li;
    }

    onSelectComplete() {
        var input_value = this.$element.val();
        var selected_el = this.$dataList.find('option[value="'+input_value+'"]');
        var isoCode = $(selected_el).attr('data-iso-code');

        this.$flagIconElement.attr('class', 'input__country-select-flag ' + isoCode);
        this.$valueElement.val(input_value);
		this.$valueElement[0].form.dispatchEvent(new Event('change'));
        this.$element.val($(selected_el).text());
        $(this.acDropdown.ul).find('li').attr('aria-selected', false);

        if (this.$marketChangeSubmitButton.length > 0) {
            if (this.itemsInCart != '0' && this.currentCountry != isoCode && this.$marketChangeSubmitButton.attr('type') == 'submit' ) {
                this.$marketChangeSubmitButton.attr('type', 'button');
                this.$marketChangeSubmitButton.attr('data-open', 'market-change-confirm-modal');
            }
        }

        if (this.$marketChangeConfirmModalValueElement.length > 0) {
            this.$marketChangeConfirmModalValueElement.val(input_value);
        }

        $( document ).trigger('country-select-change');
    }

    onChange () {
        var ul = this.acDropdown.ul;
        var input_value = this.$element.val();
        if (input_value.length == 0) {
           this.$flagIconElement.attr('class', 'input__country-select-flag');
        }
    }

    watch () {
        this.$element.on('change', this.onChange.bind(this));
        this.$element.on('awesomplete-selectcomplete', this.onSelectComplete.bind(this));
    }

    unwatch () {
        this.$element.off('change', this.onChange);
        this.$element.off('awesomplete-selectcomplete', this.onSelectComplete.bind(this));

        log('unbound', this.$element);
    }
}

CountrySelectPlugin.DEFAULTS = {
    wrapper : '.input__country-select-wrapper',
    marketChangeConfirmModalValueElement : '[name="country"]',
    marketChangeConfirmModal : '#market-change-confirm-modal',
    marketChangeSubmitButton : '#marketChangeButton',
    itemsInCartAttr : 'data-items-in-quote',
    currentCountryAttr : 'data-current-country',
    valueElement : '[type="hidden"]',
    dropDownElement : '.input__country-select__dropdown',
    dataListElement : 'datalist',
    flagIconElement : '.input__country-select-flag'
};

plugin('countrySelect', CountrySelectPlugin);

export function exec () {
    $(document).ready( () => {
        log('binding');
        $(".input__country-select").countrySelect();
        log('bound');
    });
}





// WEBPACK FOOTER //
// ./client/src/core/modules/country-select/index.js